<template lang="jade">
include ./mixin.jade
.row
  .col-xs-12
    +simpleGetButton('dxGetBaudrate')
    fieldset
      legend dxSendSerialCommand
      span signal
      input(type='text' v-model='command')
      br
      button(@click="dxSendSerialCommand(false)") send string
      button(@click="dxSendSerialCommand(true)") send b64 string
    fieldset
      legend dxSetBaudrate
      span signal
      input(type='text' v-model='baudrate')
      button(@click="dxSetBaudrate()") dxSendIRSignal
</template>

<style scoped>
  .thin {
    width: 16%;
  }
</style>
<script>
  export default {
    data: () => {
      return {
        baudrate: '9600',
        command: ''
      }
    },
    methods: {
      sendAPI (cmd, params) {
        this.$dispatch('sendAPI', cmd, params)
      },
      dxSetBaudrate () {
        this.sendAPI('dxSetBaudrate', {
          baudrate: this.baudrate
        })
      },
      dxSendSerialCommand (convert) {
        this.sendAPI('dxSendSerialCommand', {
          command: convert ? window.btoa(this.command) : this.command
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// rs232.vue?a107826a